import React from 'react';
import { connect } from 'react-redux';
import { getMerchZone } from '../actions/merchZoneActions';
import { getAvailability } from '../actions/availabilityActions';
import { MerchandiseSliderItem, ProductAvailability } from 'wbm-generic-components';
import ConfigPropMapService from '../../../../Shared/services/configPropMapService';
import ConfigPropId from '../../../../Shared/constants/configPropId';
import Slider from "react-slick";

class MainRoute extends React.Component {
    constructor(props, context) {
        super(props, context);

        const apiName = ConfigPropMapService.getConfigPropbyId(ConfigPropId.ProductAvailabilityAPIName).value;

        this.state = {
            merchZone: [],
            availability: [],
            apiName: apiName
        }

        this.getAvailability = this.getAvailability.bind(this);
    }

    isShoppingLocationAvailable() {
        const elementId = "shopping-location-json";
        const shoppingLocationJsonElement = document.getElementById(elementId);
        if (shoppingLocationJsonElement && shoppingLocationJsonElement.innerText) 
        {
            const shoppingLocation = JSON.parse(shoppingLocationJsonElement.innerText);

            return shoppingLocation.dlvModeId ? true : false;
        }
        return false;
    }

    getAvailability() {
        if (this.props.merchZone != null) {
            this.props.getAvailability(this.props.merchZone, this.state.apiName).then(() => {
                this.setState({
                    availability: this.props.availability
                })
            });
        }
    }

    componentWillMount() {
        let merchZoneId = ConfigPropMapService.getConfigPropbyId(ConfigPropId.CenterStageMerchandisingZone).value;

        this.props.getMerchZone(merchZoneId).then(() => {
            if (this.isShoppingLocationAvailable()) {
                this.getAvailability();
            }

            this.setState({
                merchZone: this.props.merchZone,
            })
        });

        document.addEventListener("shoppingLocationChanged", this.getAvailability);
    }

    componentWillUnmount() {
        document.removeEventListener("shoppingLocationChanged", this.getAvailability);
    }

    createBreakPoint(
        breakPoint,
        slidesToShow,
        displayedRecommendations
    ) {
        const mobileBreakPoint = 768;
        if (breakPoint < 768) {
            return {
                breakpoint: breakPoint,
                settings: {
                    prevArrow: <div><svg class="MuiSvgIcon-root" focusable="false" viewBox="0 0 24 24" aria-hidden="true"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path></svg></div>,
                    nextArrow: <div><svg class="MuiSvgIcon-root" focusable="false" viewBox="0 0 24 24" aria-hidden="true"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path></svg></div>,
                    draggable: true,
                    slidesToShow: slidesToShow,
                    slidesToScroll: this.getBreakpointToScroll(
                        displayedRecommendations,
                        slidesToShow
                    ),
                },
            };
        } else {
            return {
                breakpoint: breakPoint,
                settings: {
                    draggable: false,
                    slidesToShow: slidesToShow,
                    slidesToScroll: this.getBreakpointToScroll(
                        displayedRecommendations,
                        slidesToShow
                    ),
                },
            };
        }
    }

    getBreakpointToScroll(
        slides,
        slidesToShow,
        emptySlidesAllowed = 0
    ) {
    let returnValue = 1;
    const remainingSlides = slides - slidesToShow;
    for (let i = slidesToShow; i > 1; i--) {
        if (remainingSlides % i <= emptySlidesAllowed) {
            returnValue = i;
            break;
        }
    }
    return returnValue;
}

    createResponsiveBreakPoints(displayedRecommendations) {
        const productCardWidth = 215;
        const spacingBuffer = 12;
        const mobileBreakPoint = 768;
        const containerWidth = 4000;
        let responsive = [];
        let breakPointWidth = productCardWidth * 2 + spacingBuffer;
        let slidesToShow =
            (breakPointWidth - spacingBuffer) / productCardWidth - 1;
        while (breakPointWidth < containerWidth) {
            if (
                breakPointWidth > 768 &&
                breakPointWidth - productCardWidth < 768
            ) {
                responsive.push(
                    this.createBreakPoint(
                        768,
                        slidesToShow,
                        displayedRecommendations
                    )
                );
            }
            responsive.push(
                this.createBreakPoint(
                    breakPointWidth,
                    slidesToShow,
                    displayedRecommendations
                )
            );
            breakPointWidth += productCardWidth;
            slidesToShow = (breakPointWidth - spacingBuffer) / productCardWidth - 1;
        }
        responsive.push(
            this.createBreakPoint(9999999, slidesToShow, displayedRecommendations)
        );
        return responsive;
    }

    renderMerchZones() {
        let sliderSettings = {
            dots: false,
            infinite: false,
            speed: 300,
            prevArrow: <div><svg class="MuiSvgIcon-root" focusable="false" viewBox="0 0 24 24" aria-hidden="true"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path></svg></div>,
            nextArrow: <div><svg class="MuiSvgIcon-root" focusable="false" viewBox="0 0 24 24" aria-hidden="true"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path></svg></div>,
            variableWidth: true,
            responsive: [
            ]
        };
        if (this.state.merchZone != null) {
            let merchZoneSets = this.state.merchZone.merchProductSets;
            let availability = this.state.availability;

            if (merchZoneSets) {
                return merchZoneSets.sort((a, b) => b.priority - a.priority).map((merchSet, index) => {
                    sliderSettings.responsive = this.createResponsiveBreakPoints(merchSet.productSetItems.length);
                    return (<div className="merch-zone-container">
                        <div className="card-header-text font-weight-bold">
                            {merchSet.title}
                        </div>
                        <Slider {...sliderSettings}>
                            {merchSet.productSetItems.sort((a, b) => a.customSort - b.customSort).map((item, itemIndex) =>
                                <div key={itemIndex}>
                                    <MerchandiseSliderItem 
                                        productInfo={item} 
                                        displayBackground={true} 
                                        displayAddToCart={false} 
                                        productDetailsUrl={item.productDetailsUrl} 
                                        displayShopButton={true} 
                                        availabilityInfo={availability.find((availInfo) => availInfo.itemId === item.itemId && availInfo.unitId === item.unitId)}
                                    />
                                </div>
                            )}
                        </Slider>
                    </div>);
                });
            }
        }
    }

    render() {
        return (
            <div>
                {this.renderMerchZones()}
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        merchZone: state.merchZone,
        merchZoneError: state.merchZoneError,
        merchZoneLoading: state.merchZoneLoading,
        availability: state.availability
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getMerchZone: (merchZoneId) => dispatch(getMerchZone(merchZoneId)),
        getAvailability: (data, apiName) => dispatch(getAvailability(data, apiName))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(MainRoute);